import { z } from "zod";

import { WidgetDtoSchema } from "../../../dtos/widgets";

export const GetWidgetsResponseBodySchema = z.object({
  widgets: WidgetDtoSchema.array().default([]),
});
export type GetWidgetsResponseBodyType = z.infer<
  typeof GetWidgetsResponseBodySchema
>;
